import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://127.0.0.1:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export const supplierService = {
  getAll: (params = {}) => api.get('/api/suppliers/', { params }),
  getById: (id) => api.get(`/api/suppliers/${id}/`),
  create: (data) => api.post('/api/suppliers/', data),
  update: (id, data) => api.put(`/api/suppliers/${id}/`, data),
  approve: (id) => api.post(`/api/suppliers/${id}/approve/`, { action: 'approve' }),
  reject: (id, reason) => api.post(`/api/suppliers/${id}/approve/`, { action: 'reject', rejection_reason: reason }),
  toggleActive: (id) => api.post(`/api/suppliers/${id}/toggle-active/`),
  getScreening: (id) => api.get(`/api/suppliers/${id}/screening/`),
};

export const screeningService = {
  getBySupplier: (supplierId) => api.get('/api/screening/', { params: { supplier_id: supplierId } }),
  getById: (id) => api.get(`/api/screening/${id}/`),
  updateStatus: (id, status, notes = '') => api.post(`/api/screening/${id}/update-status/`, { status, notes }),
  updatePercentage: (id, percentageValue) => api.post(`/api/screening/${id}/update-percentage/`, { percentage_value: percentageValue }),
};

export const documentService = {
  getBySupplier: (supplierId) => api.get('/api/documents/', { params: { supplier_id: supplierId } }),
  getByScreeningItem: (screeningItemId) => api.get('/api/documents/', { params: { screening_item_id: screeningItemId } }),
  upload: (formData) => api.post('/api/documents/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/api/documents/${id}/`),
};

export const authService = {
  login: (username, password) => {
    const baseURL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://127.0.0.1:8000';
    return axios.post(`${baseURL}/api-token-auth/`, { username, password });
  },
  logout: () => {
    localStorage.removeItem('authToken');
  },
};

export default api;